import React from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { IMediaTypeGroup } from '../../types/mediaTypeGroup'
import { push } from '../../actions/router'
import { updateMediaTypeGroup } from '../../actions/mediaTypeGroup'
import { mediaTypeGroupValidationSchema } from '../MediaTypeGroupForm/validation'
import { NavigationGuard } from '../../components'
import MediaTypeGroupForm from '../MediaTypeGroupForm'

interface IUpdateMediaTypeGroupForm {
  mediaTypeGroup: IMediaTypeGroup
  editable?: boolean
  dispatch: Dispatch
}

export const UpdateMediaTypeGroupForm = ({
  mediaTypeGroup,
  editable,
  dispatch,
}: IUpdateMediaTypeGroupForm) => (
  <Formik
    key={mediaTypeGroup.modified}
    initialValues={mediaTypeGroup}
    onSubmit={(values) => {
      dispatch(updateMediaTypeGroup(values))
    }}
    render={(formikProps) => (
      <>
        <MediaTypeGroupForm
          formikProps={formikProps}
          editable={editable}
          submitText="Save"
          cancelAction={() => {
            formikProps.resetForm()
            dispatch(push('/settings/media-type-groups?tab=all-groups'))
          }}
        />
        <NavigationGuard isBlocking={formikProps.dirty} />
      </>
    )}
    validationSchema={mediaTypeGroupValidationSchema}
  />
)
